export default "__VITE_ASSET__CaqOGVz8__"